
<template>
  <div>
      <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <vx-card title="Category">
              <AddCategory :isPopupActive="catPopupActive" @closePopup="toggleCatPopup" :data="cateData" :catelist="categories" />
                <vs-button @click="addNewData" color="primary" type="filled">Add Category</vs-button>
                <vs-table
                    pagination
                    max-items="5"
                    search
                    stripe
                    :data="categories"
                >
                    <template slot="thead">
                    <!-- <vs-th sort-key="id">ID</vs-th> -->
                    <vs-th sort-key="name">name</vs-th>
                    <vs-th sort-key="parentCategory">Parent Category</vs-th>
                    <vs-th sort-key="description">Description</vs-th>
                    <vs-th sort-key="date">Date</vs-th>
                    <vs-th sort-key="">Actions</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                         <!-- <vs-td :data="data[indextr].id">
                        {{ data[indextr].id }}
                        </vs-td> -->

                        <vs-td :data="data[indextr].name">
                        {{ data[indextr].name }}
                        </vs-td>

                        <vs-td :data="data[indextr].parentCategory">
                        {{ data[indextr].parentCategory }}
                        </vs-td>

                        <vs-td :data="data[indextr].description">
                        {{ data[indextr].description }}
                        </vs-td>

                        <vs-td :data="data[indextr].createdAt">
                        {{ data[indextr].createdAt.substr(0,10) }}
                        </vs-td>

                        <vs-td class="whitespace-no-wrap">
                        <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
                        <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" />
                        </vs-td>
                    </vs-tr>
                    </template>
                </vs-table>
            </vx-card>          
          </div>
          <div class="vx-col md:w-1/2 w-full">
              <vx-card title="Tags">
                <AddTag :isPopupActive="tagPopupActive" @closePopup="toggleTagPopup" :data="tagData" />
                <vs-button @click="addNewTag" color="primary" type="filled">Add Tags</vs-button>
                <vs-table
                    pagination
                    max-items="5"
                    search
                    stripe
                    :data="tags"
                >
                    <template slot="thead">
                    <!-- <vs-th sort-key="id">ID</vs-th> -->
                    <vs-th sort-key="name">name</vs-th>
                    <vs-th sort-key="description">Description</vs-th>
                    <vs-th sort-key="date">Date</vs-th>
                    <vs-th >Actions</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <!-- <vs-td :data="data[indextr].id">
                        {{ data[indextr].id }}
                        </vs-td> -->

                        <vs-td :data="data[indextr].name">
                        {{ data[indextr].name }}
                        </vs-td>

                        <vs-td :data="data[indextr].description">
                        {{ data[indextr].description }}
                        </vs-td>

                        <vs-td :data="data[indextr].createdAt">
                        {{ data[indextr].createdAt.substr(0,10) }}
                        </vs-td>

                        <vs-td class="whitespace-no-wrap">
                        <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editTag(tr)" />
                        <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteTag(tr.id)" />
                        </vs-td>
                    </vs-tr>
                    </template>
                </vs-table>
                <!-- <vs-popup class="holamundo" title="Add New Category" :active.sync="catPopupActive">
                   <div>
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                            <vs-input class="w-full" label="Category Name" v-model="input9" />
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <vs-select v-model="parentCategory" class="w-full select-large" label="Parent Category">
                                    <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in parentCategory" class="w-full" />
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <vs-textarea label="Description" v-model="textarea" />
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col w-full">
                            <vs-button class="mr-3 mb-2">Submit</vs-button>
                            </div>
                        </div>
                    </div>
                </vs-popup> -->
                 <!-- <vs-popup class="holamundo" title="Add New Tags" :active.sync="tagPopupActive">
                    <div>
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                            <vs-input class="w-full" label="Tag Name" v-model="tagName" />
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <vs-textarea label="Description" v-model="textarea" />
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col w-full">
                            <vs-button class="mr-3 mb-2">Submit</vs-button>
                            </div>
                        </div>
                    </div>
                </vs-popup> -->
            </vx-card>   
          </div>
      </div>
  </div>
  
</template>

<script>
import AddCategory from '@/views/pages/products/add-category.vue'
import AddTag from '@/views/pages/products/add-tag.vue'
import moduleCategoryManagement from '@/store/categories/moduleCategoryManagement.js'
import moduleTagManagement from '@/store/tags/moduleTagManagement.js'
import moduleNotificationManagement from '@/store/notifications/moduleNotificationManagement.js'

export default {
  components:{
    AddCategory,
    AddTag
  },
  data () {
    return {
      catPopupActive: false,
      tagPopupActive: false,
      selected: [],
      isMounted: false,
      cateData: {},
      tagData: {}

      // tableList: [
      //   'vs-th: Component',
      //   'vs-tr: Component',
      //   'vs-td: Component',
      //   'thread: Slot',
      //   'tbody: Slot',
      //   'header: Slot'
      // ],
      // category: [
      //   {
      //     id: 1,
      //     name: 'Robotics',
      //     parentCategory: 'none',
      //     description: 'Lorem Ntag',
      //     date: '15-06-20'
      //   }
      // ],
      // tags: [
      //   {
      //     id: 1,
      //     name: 'Robotics',
      //     description: 'Lorem Ntag',
      //     date: '15-06-20'
      //   }
      // ],
      // cityOptions: [
      //   {text: 'None', value:'none'},
      //   {text: 'Robotics', value:'robotics'}
      // ]
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    categories () {
      return this.$store.state.categories.categories
    },
    tags () {
      return this.$store.state.tags.tags
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.categories.length
    }
  },
  methods:{
    addNewData () {
      this.cateData = {}
      this.toggleCatPopup(true)
    },
    deleteData (id) {
      this.$store.dispatch('categories/removeCategory', id)
        .then(response => {
          this.$vs.notify({
            title: 'Deleted',
            text: response.data.data,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        })
        .catch(err => { console.error(err) })
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.cateData = data
      this.toggleCatPopup(true)
    },
    addNewTag () {
      this.tagData = {}
      this.toggleTagPopup(true)
    },
    deleteTag (id) {
      this.$store.dispatch('tags/removeTag', id)
        .then(response => {
          this.$vs.notify({
            title: 'Deleted',
            text: response.data.data,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        })
        .catch(err => { console.error(err) })
    },
    editTag (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.tagData = data
      this.toggleTagPopup(true)
    },
    toggleCatPopup (val = false) {
      this.catPopupActive = val
    },
    toggleTagPopup (value = false) {
      this.tagPopupActive = value
    }
  },
  created () {
    if (!moduleCategoryManagement.isRegistered) {
      this.$store.registerModule('categories', moduleCategoryManagement)
      moduleCategoryManagement.isRegistered = true
    }
    this.$store.dispatch('categories/fetchCategories')

    if (!moduleTagManagement.isRegistered) {
      this.$store.registerModule('tags', moduleTagManagement)
      moduleTagManagement.isRegistered = true
    }
    this.$store.dispatch('tags/fetchTags')

    if (!moduleNotificationManagement.isRegistered) {
      this.$store.registerModule('notifications', moduleNotificationManagement)
      moduleNotificationManagement.isRegistered = true
    }
  },
  mounted () {
    this.isMounted = true
  }
}
</script>